import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';

export class OtpLoginForm extends BaseModel {
  encryptedUserToken?: string;
  otpContactId?: number;
  otpToken?: string;
}
